import { IAuditAdapter } from './IAuditAdapter';
import { ApiResponse } from '../../types/api';
import {
  AuditLog,
  AuditLogFilter,
  PaginatedAuditLogs,
  SecuritySettings,
  UpdateSecuritySettingsDto,
  ActiveSession,
  LoginHistoryEntry,
} from '../../types/audit';
import { ApiClient } from '../apiClient';
import { hasApiEndpoint } from '../../config/backend';

const DEMO_AUDIT_LOGS: AuditLog[] = [
  {
    log_id: 'AUD-2026-000001',
    timestamp: '2026-09-12T14:30:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'PRIORITY_CHANGE',
    entity_type: 'Complaint',
    entity_id: 'CMP-2026-00245',
    old_values: { priority_id: 'PRI-002', priority_name: 'Medium' },
    new_values: { priority_id: 'PRI-004', priority_name: 'Critical' },
    description: 'Priority escalated from Medium to Critical',
  },
  {
    log_id: 'AUD-2026-000002',
    timestamp: '2026-09-12T14:15:00Z',
    user_id: 'USR-00002',
    user_name: 'John Officer',
    ip_address: '192.168.1.22',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Safari/17.0',
    action: 'CREATE',
    entity_type: 'WorkOrder',
    entity_id: 'WO-2026-00156',
    new_values: { work_order_id: 'WO-2026-00156', complaint_id: 'CMP-2026-00245', vendor_id: 'VND-00003', status: 'Assigned' },
    description: 'New work order created from complaint CMP-2026-00245',
  },
  {
    log_id: 'AUD-2026-000003',
    timestamp: '2026-09-12T13:45:00Z',
    user_id: 'USR-00003',
    user_name: 'Priya Supervisor',
    ip_address: '192.168.1.35',
    user_agent: 'Mozilla/5.0 (Linux; Android 13) Chrome/119.0 Mobile',
    action: 'STATUS_CHANGE',
    entity_type: 'Complaint',
    entity_id: 'CMP-2026-00239',
    old_values: { status_id: 'STA-003', status_name: 'Assigned' },
    new_values: { status_id: 'STA-004', status_name: 'In Progress' },
    description: 'Status changed Assigned to In Progress',
  },
  {
    log_id: 'AUD-2026-000004',
    timestamp: '2026-09-12T12:00:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'LOGIN',
    entity_type: 'User',
    entity_id: 'USR-00001',
    metadata: { channel: 'web' },
    description: 'Admin login successful',
  },
  {
    log_id: 'AUD-2026-000005',
    timestamp: '2026-09-12T11:42:00Z',
    user_id: 'USR-00005',
    user_name: 'Vendor Alpha',
    ip_address: '203.0.113.45',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0) Safari/604.1',
    action: 'ASSIGNMENT',
    entity_type: 'Technician',
    entity_id: 'TEC-00012',
    old_values: { technician_id: null },
    new_values: { technician_id: 'TEC-00012', work_order_id: 'WO-2026-00152' },
    description: 'Technician assigned to work order WO-2026-00152',
  },
  {
    log_id: 'AUD-2026-000006',
    timestamp: '2026-09-12T10:20:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'CONFIG_CHANGE',
    entity_type: 'Config',
    entity_id: 'sla_enabled',
    old_values: { sla_enabled: false },
    new_values: { sla_enabled: true },
    description: 'SLA tracking enabled',
  },
  {
    log_id: 'AUD-2026-000007',
    timestamp: '2026-09-12T09:05:00Z',
    user_id: 'USR-00011',
    user_name: 'Dept User',
    ip_address: '192.168.1.88',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/121.0',
    action: 'CREATE',
    entity_type: 'Complaint',
    entity_id: 'CMP-2026-00246',
    new_values: { complaint_id: 'CMP-2026-00246', title: 'AC water leakage in server room', status: 'New' },
    description: 'New complaint raised',
  },
  {
    log_id: 'AUD-2026-000008',
    timestamp: '2026-09-12T08:30:00Z',
    user_id: 'USR-00007',
    user_name: 'Unknown',
    ip_address: '198.51.100.7',
    user_agent: 'curl/8.4.0',
    action: 'FAILED_LOGIN',
    entity_type: 'User',
    entity_id: '',
    metadata: { email: 'admin@nad.com', reason: 'Invalid password' },
    description: 'Failed login attempt - invalid password',
  },
  {
    log_id: 'AUD-2026-000009',
    timestamp: '2026-09-11T17:50:00Z',
    user_id: 'USR-00002',
    user_name: 'John Officer',
    ip_address: '192.168.1.22',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Safari/17.0',
    action: 'UPDATE',
    entity_type: 'Vendor',
    entity_id: 'VND-00002',
    old_values: { category: 'Plumbing', rating: 4.1 },
    new_values: { category: 'Plumbing & Civil', rating: 4.3 },
    description: 'Vendor profile updated',
  },
  {
    log_id: 'AUD-2026-000010',
    timestamp: '2026-09-11T16:15:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'EXPORT',
    entity_type: 'Complaint',
    entity_id: 'complaints_report',
    metadata: { format: 'xlsx', rows: 245, filters: { status: 'Closed' } },
    description: 'Exported closed complaints report to Excel',
  },
  {
    log_id: 'AUD-2026-000011',
    timestamp: '2026-09-11T15:00:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'ROLE_CHANGE',
    entity_type: 'User',
    entity_id: 'USR-00020',
    old_values: { role: 'DEPARTMENT_USER' },
    new_values: { role: 'SUPERVISOR' },
    description: 'User role changed to Supervisor',
  },
  {
    log_id: 'AUD-2026-000012',
    timestamp: '2026-09-11T14:00:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'DELETE',
    entity_type: 'Category',
    entity_id: 'CAT-099',
    old_values: { category_id: 'CAT-099', name: 'Obsolete Category' },
    description: 'Obsolete category deleted',
  },
  {
    log_id: 'AUD-2026-000013',
    timestamp: '2026-09-11T12:30:00Z',
    user_id: 'USR-00003',
    user_name: 'Priya Supervisor',
    ip_address: '192.168.1.35',
    user_agent: 'Mozilla/5.0 (Linux; Android 13) Chrome/119.0 Mobile',
    action: 'LOGOUT',
    entity_type: 'User',
    entity_id: 'USR-00003',
    description: 'User logged out',
  },
  {
    log_id: 'AUD-2026-000014',
    timestamp: '2026-09-11T11:10:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'ARCHIVE',
    entity_type: 'Complaint',
    entity_id: 'CMP-2025-00089',
    metadata: { archived_after_days: 90, target: 'Archive_Complaints' },
    description: 'Complaint archived after 90 days',
  },
  {
    log_id: 'AUD-2026-000015',
    timestamp: '2026-09-11T09:45:00Z',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    action: 'PASSWORD_CHANGE',
    entity_type: 'User',
    entity_id: 'USR-00015',
    description: 'User password changed',
  },
];

const DEMO_SECURITY_SETTINGS: SecuritySettings = {
  password_min_length: 4,
  password_require_uppercase: false,
  password_require_numbers: false,
  password_require_special: false,
  session_timeout_minutes: 30,
  max_login_attempts: 5,
  lockout_duration_minutes: 15,
  access_token_expiry_minutes: 60,
  refresh_token_expiry_days: 7,
  enforce_password_history: 5,
  require_2fa: false,
};

const DEMO_SESSIONS: ActiveSession[] = [
  {
    session_id: 'SES-00001',
    user_id: 'USR-00001',
    user_name: 'System Admin',
    ip_address: '192.168.1.10',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0',
    created_at: '2026-09-12T12:00:00Z',
    last_active: '2026-09-12T14:32:00Z',
    is_current: true,
  },
  {
    session_id: 'SES-00002',
    user_id: 'USR-00002',
    user_name: 'John Officer',
    ip_address: '192.168.1.22',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Safari/17.0',
    created_at: '2026-09-12T09:10:00Z',
    last_active: '2026-09-12T14:20:00Z',
    is_current: false,
  },
  {
    session_id: 'SES-00003',
    user_id: 'USR-00003',
    user_name: 'Priya Supervisor',
    ip_address: '192.168.1.35',
    user_agent: 'Mozilla/5.0 (Linux; Android 13) Chrome/119.0 Mobile',
    created_at: '2026-09-12T08:00:00Z',
    last_active: '2026-09-12T13:50:00Z',
    is_current: false,
  },
  {
    session_id: 'SES-00004',
    user_id: 'USR-00005',
    user_name: 'Vendor Alpha',
    ip_address: '203.0.113.45',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0) Safari/604.1',
    created_at: '2026-09-12T07:30:00Z',
    last_active: '2026-09-12T11:45:00Z',
    is_current: false,
  },
];

const DEMO_LOGIN_HISTORY: LoginHistoryEntry[] = [
  { log_id: 'AUD-2026-000004', user_id: 'USR-00001', user_name: 'System Admin', email: 'admin@nad.com', ip_address: '192.168.1.10', user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0', status: 'SUCCESS', timestamp: '2026-09-12T12:00:00Z' },
  { log_id: 'AUD-2026-000008', user_id: 'USR-00007', user_name: 'Unknown', email: 'admin@nad.com', ip_address: '198.51.100.7', user_agent: 'curl/8.4.0', status: 'FAILED', failure_reason: 'Invalid password', timestamp: '2026-09-12T08:30:00Z' },
  { log_id: 'AUD-2026-000020', user_id: 'USR-00002', user_name: 'John Officer', email: 'john.officer@nad.com', ip_address: '192.168.1.22', user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Safari/17.0', status: 'SUCCESS', timestamp: '2026-09-12T09:10:00Z' },
  { log_id: 'AUD-2026-000021', user_id: 'USR-00003', user_name: 'Priya Supervisor', email: 'priya.supervisor@nad.com', ip_address: '192.168.1.35', user_agent: 'Mozilla/5.0 (Linux; Android 13) Chrome/119.0 Mobile', status: 'SUCCESS', timestamp: '2026-09-12T08:00:00Z' },
  { log_id: 'AUD-2026-000022', user_id: 'USR-00005', user_name: 'Vendor Alpha', email: 'contact@vendoralpha.com', ip_address: '203.0.113.45', user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0) Safari/604.1', status: 'SUCCESS', timestamp: '2026-09-12T07:30:00Z' },
  { log_id: 'AUD-2026-000023', user_id: 'USR-00011', user_name: 'Dept User', email: 'dept.user@nad.com', ip_address: '192.168.1.88', user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/121.0', status: 'FAILED', failure_reason: 'Account locked', timestamp: '2026-09-11T18:20:00Z' },
  { log_id: 'AUD-2026-000024', user_id: 'USR-00011', user_name: 'Dept User', email: 'dept.user@nad.com', ip_address: '192.168.1.88', user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/121.0', status: 'SUCCESS', timestamp: '2026-09-11T18:25:00Z' },
  { log_id: 'AUD-2026-000025', user_id: 'USR-00001', user_name: 'System Admin', email: 'admin@nad.com', ip_address: '192.168.1.10', user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0', status: 'SUCCESS', timestamp: '2026-09-11T08:05:00Z' },
];

let auditLogs = [...DEMO_AUDIT_LOGS];
let securitySettings = { ...DEMO_SECURITY_SETTINGS };
let sessions = [...DEMO_SESSIONS];
let loginHistory = [...DEMO_LOGIN_HISTORY];
let auditCounter = auditLogs.length;

const delay = (ms = 300) => new Promise(r => setTimeout(r, ms));
const ok = <T>(data: T, message = 'OK'): ApiResponse<T> => ({ success: true, data, message });

const nextLogId = () => {
  auditCounter += 1;
  return `AUD-2026-${String(auditCounter).padStart(6, '0')}`;
};

const sortByTimestampDesc = (logs: AuditLog[]) =>
  [...logs].sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

export class GASAuditAdapter implements IAuditAdapter {
  async getAuditLogs(filter?: AuditLogFilter): Promise<ApiResponse<PaginatedAuditLogs>> {
    if (!hasApiEndpoint()) {
      await delay();
      let results = sortByTimestampDesc(auditLogs);

      if (filter?.action) results = results.filter(l => l.action === filter.action);
      if (filter?.entity_type) results = results.filter(l => l.entity_type === filter.entity_type);
      if (filter?.user_id) results = results.filter(l => l.user_id === filter.user_id);
      if (filter?.date_from) results = results.filter(l => new Date(l.timestamp) >= new Date(filter.date_from!));
      if (filter?.date_to) results = results.filter(l => new Date(l.timestamp) <= new Date(filter.date_to!));
      if (filter?.search) {
        const q = filter.search.toLowerCase();
        results = results.filter(l =>
          l.entity_id.toLowerCase().includes(q) ||
          l.user_name?.toLowerCase().includes(q) ||
          l.description?.toLowerCase().includes(q) ||
          l.log_id.toLowerCase().includes(q)
        );
      }

      const page = filter?.page || 1;
      const limit = filter?.limit || 25;
      const total = results.length;
      const totalPages = Math.max(1, Math.ceil(total / limit));
      const paged = results.slice((page - 1) * limit, page * limit);

      return ok({ logs: paged, total, page, limit, totalPages });
    }

    const query = filter ? `?${new URLSearchParams(filter as any).toString()}` : '';
    const res = await ApiClient.get<AuditLog[] | PaginatedAuditLogs>(`/audit/logs${query}`);
    if (res.success && Array.isArray(res.data)) {
      const page = filter?.page || 1;
      const limit = filter?.limit || 25;
      const all = res.data;
      return ok({
        logs: all.slice((page - 1) * limit, page * limit),
        total: all.length,
        page,
        limit,
        totalPages: Math.max(1, Math.ceil(all.length / limit)),
      });
    }
    return res as unknown as ApiResponse<PaginatedAuditLogs>;
  }

  async getAuditLogById(id: string): Promise<ApiResponse<AuditLog>> {
    if (!hasApiEndpoint()) {
      await delay();
      const log = auditLogs.find(l => l.log_id === id);
      if (!log) return { success: false, data: null as unknown as AuditLog, message: 'Audit log not found', errors: ['NOT_FOUND'] };
      return ok(log);
    }
    const res = await ApiClient.get<AuditLog[]>(`/audit/logs?limit=100000`);
    if (res.success) {
      const log = (res.data || []).find(l => l.log_id === id);
      if (log) return ok(log);
    }
    return { success: false, data: null as unknown as AuditLog, message: 'Audit log not found', errors: ['NOT_FOUND'] };
  }

  async getEntityHistory(entityType: string, entityId: string): Promise<ApiResponse<AuditLog[]>> {
    if (!hasApiEndpoint()) {
      await delay();
      const results = sortByTimestampDesc(
        auditLogs.filter(l => l.entity_type.toLowerCase() === entityType.toLowerCase() && l.entity_id === entityId)
      );
      return ok(results);
    }
    return ApiClient.get<AuditLog[]>(`/audit/logs/${entityType}/${entityId}`);
  }

  async exportAuditLogs(filter?: AuditLogFilter): Promise<ApiResponse<AuditLog[]>> {
    if (!hasApiEndpoint()) {
      await delay();
      let results = sortByTimestampDesc(auditLogs);
      if (filter?.action) results = results.filter(l => l.action === filter.action);
      if (filter?.entity_type) results = results.filter(l => l.entity_type === filter.entity_type);
      if (filter?.date_from) results = results.filter(l => new Date(l.timestamp) >= new Date(filter.date_from!));
      if (filter?.date_to) results = results.filter(l => new Date(l.timestamp) <= new Date(filter.date_to!));
      return ok(results);
    }
    const params = new URLSearchParams({ ...(filter as any), limit: '100000' }).toString();
    return ApiClient.get<AuditLog[]>(`/audit/logs?${params}`);
  }

  async createAuditLog(log: Partial<AuditLog>): Promise<ApiResponse<AuditLog>> {
    if (!hasApiEndpoint()) {
      await delay(100);
      const newLog: AuditLog = {
        log_id: log.log_id || nextLogId(),
        timestamp: log.timestamp || new Date().toISOString(),
        user_id: log.user_id || '',
        user_name: log.user_name,
        ip_address: log.ip_address || '',
        user_agent: log.user_agent || '',
        action: log.action || 'UPDATE',
        entity_type: log.entity_type || 'System',
        entity_id: log.entity_id || '',
        old_values: log.old_values,
        new_values: log.new_values,
        metadata: log.metadata,
        description: log.description,
      };
      auditLogs.push(newLog);
      return ok(newLog, 'Audit log created');
    }
    return ApiClient.post<AuditLog>('/audit/logs', log);
  }

  async getSecuritySettings(): Promise<ApiResponse<SecuritySettings>> {
    if (!hasApiEndpoint()) {
      await delay();
      return ok(securitySettings);
    }
    return ApiClient.get<SecuritySettings>('/security/settings');
  }

  async updateSecuritySettings(dto: UpdateSecuritySettingsDto): Promise<ApiResponse<SecuritySettings>> {
    if (!hasApiEndpoint()) {
      await delay(400);
      securitySettings = { ...securitySettings, ...dto };
      auditLogs.push({
        log_id: nextLogId(),
        timestamp: new Date().toISOString(),
        user_id: 'USR-00001',
        user_name: 'System Admin',
        ip_address: '192.168.1.10',
        user_agent: navigator.userAgent,
        action: 'CONFIG_CHANGE',
        entity_type: 'Config',
        entity_id: 'security_settings',
        old_values: { ...DEMO_SECURITY_SETTINGS },
        new_values: { ...dto },
        description: 'Security settings updated',
      });
      return ok(securitySettings, 'Security settings updated');
    }
    return ApiClient.put<SecuritySettings>('/security/settings', dto);
  }

  async getActiveSessions(): Promise<ApiResponse<ActiveSession[]>> {
    if (!hasApiEndpoint()) {
      await delay();
      return ok(sessions);
    }
    return ApiClient.get<ActiveSession[]>('/security/sessions');
  }

  async revokeSession(id: string): Promise<ApiResponse<void>> {
    if (!hasApiEndpoint()) {
      await delay(400);
      sessions = sessions.filter(s => s.session_id !== id);
      return ok(undefined as unknown as void, 'Session revoked');
    }
    return ApiClient.delete<void>(`/security/sessions/${id}`);
  }

  async getLoginHistory(userId?: string): Promise<ApiResponse<LoginHistoryEntry[]>> {
    if (!hasApiEndpoint()) {
      await delay();
      const results = [...loginHistory].sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
      return ok(userId ? results.filter(h => h.user_id === userId) : results);
    }
    return ApiClient.get<LoginHistoryEntry[]>(`/security/login-history${userId ? `?user_id=${userId}` : ''}`);
  }
}
